<template>
  <div
    class="tbale_dig"
    :style="{

      left: left,
      top: top,
      height: height,
      width: width,
    }"
    id="tbale_dig"
  >
    <div class="icon_cont">
      <i @click="closeDialog" class="close_cont el-icon-close"></i>
    </div>
    <div class="table_title">{{ title }}</div>
    <div class="search-box" v-if="dialogType == 'person'">
      <el-input
        clearable
        class="unglobal-sty"
        v-model="keyword"
        placeholder="请输入"
        @input="GetKeyword"
        style="color: #fff"
      ></el-input>
    </div>
    <div class="topTitle" v-if="dialogType == 'alarm'">
      <div
        class="title_item"
        v-for="(item, index) in titleList"
        :key="index"
        @click="changeTitle(item, index)"
      >
        <div
          class="item_span"
          :class="index == activeIndex ? 'active' : ''"
          :style="{
            backgroundImage:
              index == activeIndex
                ? `url(${require('../assets/image/img_title.png')})`
                : ``,
          }"
        >
          {{ item.lable }}
        </div>
      </div>
    </div>
    <div class="table_cont">
      <el-table
        v-loading="loading"
        :data="tableData"
        :height="
          dialogType == 'person' ? 272 : dialogType == 'alarm' ? 290 : 300
        "
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#2B4A6F',
          color: '#ffffff',
        }"
        :row-style="{ cursor: 'pointer' }"
        class="unglobal-sty"
        @row-click="rowCilck"
      >
        <el-table-column
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          align="center"
          :show-overflow-tooltip="true"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="scope.column.property == 'name'">
              <span style="color: #75c7ff">{{
                scope.row[scope.column.property]
              }}</span>
            </div>
            <div v-else-if="scope.column.property == 'status'">
              <span
                :style="{
                  color:
                    scope.row[scope.column.property] == '在厂'
                      ? '#0DA537'
                      : scope.row[scope.column.property] == '已退厂'
                      ? '#A6715A'
                      : scope.row[scope.column.property] == '黑名单'
                      ? '#E33122'
                      : '',
                }"
                >{{ scope.row[scope.column.property] }}</span
              >
            </div>
            <div v-else-if="scope.column.property == 'alarm'">
              <span>{{
                scope.row[scope.column.property] == "0"
                  ? "通知"
                  : scope.row[scope.column.property] == "1"
                  ? "报警"
                  : ""
              }}</span>
            </div>
            <div v-else>
              <span class="truncate">{{
                scope.row[scope.column.property]
              }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tab_pog">
      <el-pagination
        class="unglobal-sty"
        background
        layout="prev, pager, next"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page.sync="page.pageNo"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <PersonDetail
      v-if="detailVisible"
      ref="personDetail"
      :visible="detailVisible"
      :personId="personDetailId"
      @close="detailVisible = false"
    ></PersonDetail>
    <div
      class="message_tips"
      v-if="messageDialog"
      :style="{
        backgroundImage: `url(${require('../assets/image/dialog_bg.png')})`,
      }"
    >
      <div class="message_top">提示</div>
      <div class="message_warnning">
        <div class="message">
          <div class="icon">
            <img src="../assets/image/tip_icon.png" alt="" />
          </div>
          <div>确认关闭报警吗？</div>
        </div>
        <div class="button">
          <div
            class="confirm_btn"
            style="margin-right: 10px; background-color: #3e587e; color: #fff"
            @click="confirm()"
          >
            确认
          </div>
          <div class="confirm_btn" @click="messageDialog = false">取消</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonDetail from './PersonDetail.vue'
import CockpitService from '../service/index'

export default {
  components: {
    PersonDetail,
  },
  props: {
    dialogType: {
      type: String,
      default: () => { return '' },
    },
    visible: {
      type: Boolean,
      default: () => { return false },
    },
    deptName: {
      type: String,
      default: () => { return '' },
    },
    left: {
      type: String,
      default: () => { return 'calc(100% + 30px)' },
    },
    top: {
      type: String,
      default: () => { return '80px' },
    },
    height: {
      type: String,
      default: () => { return '455px' },
    },
    width: {
      type: String,
      default: () => { return '785px' },
    },
  },
  data() {
    return {
      title: '单位人员清单',
      keyword: '',
      tableData: [],
      tableColumnList: [
        {
          prop: 'name',
          label: '姓名',
          width: '100',
        },
        {
          prop: 'personType',
          label: '人员分类',
          width: '100',
        },
        {
          prop: 'office',
          label: '职务/工种',
          width: '100',
        },
        {
          prop: 'status',
          label: '人员状态',
          width: '100',
        },
        {
          prop: 'days',
          label: '在场天数（天）',
          width: '120',
        },
        {
          prop: 'todayHour',
          label: '今日在场时长（h）',
          width: '',
        },
      ],
      page: {
        total: 0,
        pageNo: 1,
        pageSize: 15,
      },
      dialogVisible: false,
      detailVisible: false,
      personDetailId: '',
      titleList: [
        {
          lable: '环境报警',
        },
        {
          lable: '深基坑',
        },
        {
          lable: '塔吊检测',
        },
        {
          lable: '高支模',
        },
      ],
      activeIndex: 0,
      messageDialog: false,
      loading: false,
    }
  },
  watch: {
    deptName() {
      this.keyword = ''
      this.page.pageNo = 1
      this.getPersonnelDetail(this.deptName)
    },
  },
  created() {
    this.getPersonnelDetail(this.deptName)
  },
  methods: {
    // lodash - debounce - 防抖节流 - GetKeyword - 需要传递参数,GetKeyword能拿到input的val - e
    GetKeyword: _.debounce(function (e) {
      this.getKeyword(e)
    }, 500),

    getKeyword(val) {
      this.keyword = val
      this.getPersonnelDetail(this.deptName, 'search')
    },
    rowCilck(row) {
      if (this.dialogType == 'person') {
        this.personDetailId = row.idCard
        this.detailVisible = true
        this.$nextTick(() => {
          this.$refs.personDetail.isRequesting = true
          this.$refs.personDetail.togetAnalyse()
          this.$refs.personDetail.showGif = true
        })
      }
    },
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getPersonnelDetail(this.deptName)
    },
    changeTitle(row, index) {
      this.activeIndex = index
      this.onRest()
      this.getPersonnelDetail(this.deptName)
    },
    handleClick(row) {
      this.messageDialog = true
    },
    confirm() {
      this.messageDialog = false
    },
    async getPersonnelDetail(type, search) {
      if (search === 'search') {
        this.page.pageNo = 1
        this.page.total = 0
      }
      this.tableData = []
      if (this.dialogType == 'person' && type != '') {
        this.loading = true
        this.title = '单位人员清单'
        const param = {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          keyWord: this.keyword,
          deptId: type,
        }
        const [err, res] = await CockpitService.getParticipatePersonList(param)
        if (res && res.code == 0) {
          this.tableColumnList = []
          this.tableColumnList = [
            {
              prop: 'name',
              label: '姓名',
              width: '100',
            },
            {
              prop: 'personType',
              label: '人员分类',
              width: '100',
            },
            {
              prop: 'office',
              label: '职务/工种',
              width: '100',
            },
            {
              prop: 'status',
              label: '人员状态',
              width: '100',
            },
            {
              prop: 'days',
              label: '在场天数（天）',
              width: '120',
            },
            {
              prop: 'todayHour',
              label: '今日在场时长（h）',
              width: '',
            },
          ]
          this.tableData = res.data.items
          this.page.total = res.data.totalCount
        } else {
        }
        this.loading = false
      }
    },
    closeDialog() {
      this.page.pageNo = 1
      this.dialogVisible = false
      this.activeIndex = 0
      this.$emit('close')
    },
    onRest() {
      this.page = {
        total: 0,
        pageNo: 1,
        pageSize: 15,
      }
    },
    async changeListWithTable(param, columnList, request) {
      this.loading = true
      const res = await request(param)
      if ((res && res.code == 0) || res.success == true) {
        // this.tableColumnList = [];
        console.log(res, 'res----------')
        // this.tableColumnList = columnList;
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/css/index.scss";
#tbale_dig {
  background-image: var(--dialogBgImg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  position: absolute;
  z-index: 101;
  .icon_cont {
    text-align: right;
    margin: 20px 20px 0 0;
    position: relative;
    height: 20px;
    .el-button {
      padding: 5px !important;
      background: #3fbaff4c !important;
      color: #fff;
    }
    .close_cont {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 2px;
      background: rgba(63, 186, 255, 0.2980392157) !important;
      color: #fff;
      cursor: pointer;
      border: 1px solid #d9d9d9;
    }
  }
  .table_title {
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
  }
  .search-box {
    display: flex;
    align-items: center;
    padding: 0px 0px 0px 20px;
    .el-form-item--mini.el-form-item {
      margin-bottom: 0px;
    }
    .el-input {
      width: 200px;
      // color: white !important;
    }
  }
  .topTitle {
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-content: center;
    justify-content: start;
    margin-top: 13px;
    .title_item {
      width: 138px;
      height: 38px;
      text-align: center;
      line-height: 32px;
      padding: 2px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      border: 0.858px solid rgba(255, 255, 255, 0.12);
      border-radius: 2px;
      cursor: pointer;
      .item_span {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.12);
        border-radius: 2px;
      }
    }
    & > .title_item:nth-of-type(2) {
      margin: 0 20px;
    }
    & > .title_item:nth-of-type(3) {
      margin-right: 20px;
    }
    .active {
      position: relative;
      // background-image: url("../assets/homeImg/img_title.png") !important;
      background-repeat: no-repeat !important;
      background-size: 100% 100% !important;
      background-position: center 0 !important;
      color: #fff !important;
      font-size: 16px;
      font-weight: bold !important;
    }
    .active::before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 6px;
      left: 2px;
      width: 1px;
      height: 20px;
      background-color: #fff;
    }
    .active::after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 6px;
      right: 2px;
      width: 1px;
      height: 20px;
      background-color: #fff;
    }
  }
  .table_cont {
    padding: 20px 20px 5px 20px;
    .tableBtn {
      color: rgba(117, 199, 255, 1);
    }
  }
  .tab_pog {
    text-align: center !important;
  }
  .message_tips {
    width: 541px;
    height: 205px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center 0;
    position: absolute;
    left: 80px;
    top: 510px;
    color: #fff;
    .message_top {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 24px;
      padding-left: 73px;
      margin-bottom: 8px;
    }
    .message_warnning {
      width: 100%;
      height: 147px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .message {
        display: flex;
        font-size: 24px;
        line-height: 34px;
        color: #eee;
        .icon {
          width: 31px;
          height: 31px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .button {
        display: flex;
        margin-top: 24px;
        .confirm_btn {
          width: 80px;
          height: 36px;
          border: 1px solid #5479a3;
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          color: #7cade4;
          font-size: 14px;
        }
      }
    }
  }
  ::v-deep .el-input .el-input__inner {
    width: 200px;
    color: white !important;
    background-color: transparent !important;
  }

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 30px) !important;
  }
  // ::v-deep .el-form-item {
  //   width: auto !important;
  // }
  ::v-deep {
    .el-table__row .cell.el-tooltip {
      min-height: 10px;
      white-space: pre-wrap;
      text-align: center;
    }
  }
}
::v-deep .el-table {
  th.gutter,
  colgroup.gutter {
    width: 5px !important;
  }
}
::v-deep .el-table__header colgroup col[name="gutter"] {
  display: table-cell !important;
}
.truncate {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
}
</style>
